module.exports = __webpack_public_path__ + "img/doublecard2.029c7f94.webp";